const icon = document.getElementById("quick-search-icon");
const header = document.getElementById("header");
const shadowElement = document.getElementById("header__top-section");
const searchBar = document.getElementById("quick-search-component");
const midPageMenu = document.getElementById("product-content__menu-container");

let sticky = 56;

if (header) {
    if (header.offsetTop > 0) {
        icon.classList.remove("no-opacity");
        if (document.body.clientWidth >= 1023 - 17) {
            shadowElement.classList.add("box-shadow");
        }
    } else {
        searchBar.classList.remove("no-height");
        shadowElement.classList.remove("box-shadow");
    }
    window.addEventListener("scroll", function () {
        if (header.offsetTop <= 0) {
            shadowElement.classList.remove("box-shadow");
        }
        if (document.body.clientWidth <= 1023 - 17) {
            if (
                document.documentElement.scrollTop < 160 &&
                searchBar.classList.contains("no-scroll")
            ) {
                searchBar.classList.remove("no-scroll");
                if (midPageMenu) {
                    midPageMenu.classList.remove("sticky--menu-open");
                }

                if (searchBar.classList.contains("no-height")) {
                    searchBar.classList.remove("no-height");
                }
            }
            if (!searchBar.classList.contains("no-scroll")) {
                if (window.pageYOffset > sticky) {
                    searchBar.classList.add("no-height");
                    icon.classList.remove("no-opacity");
                } else {
                    searchBar.classList.remove("no-height");
                    icon.classList.add("no-opacity");
                }
            }
            if (!midPageMenu) {
                if (window.pageYOffset > sticky) {
                    shadowElement.classList.add("box-shadow");
                } else {
                    shadowElement.classList.remove("box-shadow");
                }
            }
        } else {
            if (!midPageMenu) {
                if (window.pageYOffset > sticky) {
                    shadowElement.classList.add("box-shadow");
                } else {
                    shadowElement.classList.remove("box-shadow");
                }
            }
        }
    });
}

if (icon) {
    icon.addEventListener("click", function () {
        if (searchBar.classList.contains("no-height")) {
            searchBar.classList.add("no-scroll");
            searchBar.classList.remove("no-height");
            if (midPageMenu) {
                midPageMenu.classList.add("sticky--menu-open");
            }
        } else {
            searchBar.classList.add("no-height");
            searchBar.classList.remove("no-scroll");
            if (midPageMenu) {
                midPageMenu.classList.remove("sticky--menu-open");
            }
        }
    });
}
